import { useTranslation } from 'react-i18next';

interface StatusBarProps {
    availableCount: number;
    unavailableCount: number;
    requestOrderCount: number;
    supportCounts: number;
    newOrderCounts: number;
    chefCounts: number;
}

export default function StatusBar({ availableCount, unavailableCount, supportCounts, newOrderCounts, chefCounts }: StatusBarProps) {

    const { t } = useTranslation();

    return (
        <div className="flex justify-between items-center sticky bg-transparent w-full top-4 z-10">
            <h2 className="text-[#000000] font-bold text-[20px] bg-[#F1F5F9] p-2 rounded-lg  hidden md:block">{t("order")}</h2>
            <div className="bg-white py-2 px-4 rounded-full hidden md:flex justify-center items-center gap-4">
                <div className="flex items-center gap-2">
                    <span className="relative flex size-3">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-purple-400 opacity-75"></span>
                        <span className="relative inline-flex size-3 rounded-full bg-purple-500"></span>
                    </span>
                    <span className="text-[12px] lg:text-[14px] font-medium">{t("support")}{supportCounts > 0 && ` (${supportCounts})`}</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="relative flex size-3">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-blue-400 opacity-75"></span>
                        <span className="relative inline-flex size-3 rounded-full bg-blue-500"></span>
                    </span>
                    <span className="text-[12px] lg:text-[14px] font-medium">{t("newOrder")}{newOrderCounts > 0 && ` (${newOrderCounts})`}</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="relative flex size-3">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75"></span>
                        <span className="relative inline-flex size-3 rounded-full bg-green-500"></span>
                    </span>
                    <span className="text-[12px] lg:text-[14px] font-medium">{t("ready")}{chefCounts > 0 && ` (${chefCounts})`}</span>
                </div>
                <div className="border-r border-gray-300 h-4 rounded-full" />
                <div className="flex items-center gap-2">
                    <span className="relative inline-flex size-3 rounded-full bg-gray-500"></span>
                    <span className="text-[12px] lg:text-[14px] font-medium">{t("available")}{availableCount > 0 && ` (${availableCount})`}</span>
                </div >
                {/* <div className="flex items-center gap-2">
                    <span className="relative inline-flex size-3 rounded-full bg-yellow-500"></span>
                    <span>{t("requestOrder")}{requestOrderCount > 0 && ` (${requestOrderCount})`}</span>
                </div> */}
                <div className="flex items-center gap-2">
                    <span className="relative inline-flex size-3 rounded-full bg-danger"></span>
                    <span className="text-[12px] lg:text-[14px] font-medium">{t("unavailable")}{unavailableCount > 0 && ` (${unavailableCount})`}</span>
                </div>
            </div>
        </div>
    )
}
